import React, { useEffect, useState } from "react";
import { collection, getDocs, updateDoc, doc,getDoc } from "firebase/firestore";
import { db } from "../api/firebase";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";

const LinkCommentList = () => {
  const [reiLinks, setReiLinks] = useState([]);
  const [ddpLinks, setDdpLinks] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLinks = async () => {
    // 🔄 クリアしてから取得
    setReiLinks([]);
    setDdpLinks([]);
    setLoading(true);

    // ReiNoInori
    const reiSnap = await getDocs(collection(db, "ReiNoInori"));
    const filteredRei = reiSnap.docs
      .filter(doc => doc.data().comment?.includes("https"))
      .map((doc, index) => ({
        index: index + 1,
        id: doc.id,
        comment: doc.data().comment,
      }));
    setReiLinks(filteredRei);

    // reviewableDDPs
    const ddpSnap = await getDocs(collection(db, "reviewableDDPs"));
    let ddpResult = [];
    ddpSnap.docs.forEach(doc => {
      const adviceArray = doc.data().advice || [];
      adviceArray.forEach((advice, idx) => {
        if (advice.comment?.includes("https")) {
          ddpResult.push({
            id: doc.id,
            adviceIndex: idx,
            comment: advice.comment,
          });
        }
      });
    });

    setDdpLinks(
      ddpResult.map((item, index) => ({
        ...item,
        index: index + 1,
      }))
    );

    setLoading(false);
  };

  useEffect(() => {
    fetchLinks();
  }, []);

  const handleDeleteReiFields = async () => {
    if (!window.confirm("ReiNoInori の対象フィールドを削除しますか？")) return;

    setLoading(true);
    const promises = reiLinks.map((item) =>
      updateDoc(doc(db, "ReiNoInori", item.id), {
        comment: null,
        commentedBy: null,
        mailedBy: null,
        applicant: null,
        applied: null,
      })
    );
    await Promise.all(promises);
    await fetchLinks();
  };

  const handleDeleteDDPAdvice = async () => {
    if (!window.confirm("reviewableDDPs の対象 advice 要素を削除しますか？")) return;
  
    setLoading(true);
  
    // 重複排除のため Map（docId -> true） で管理
    const docIdsToProcess = Array.from(new Set(ddpLinks.map(item => item.id)));
  
    const updatePromises = docIdsToProcess.map(async (docId) => {
      const ref = doc(db, "reviewableDDPs", docId);
      const snap = await getDoc(ref);
      if (!snap.exists()) return;
  
      const data = snap.data();
      const originalAdvice = data.advice || [];
  
      // comment に "https" を含まない要素だけを残す
      const filteredAdvice = originalAdvice.filter(
        (entry) => !entry.comment?.includes("https")
      );
  
      // 更新（https を含む要素だけ削除）
      await updateDoc(ref, { advice: filteredAdvice });
    });
  
    await Promise.all(updatePromises);
    await fetchLinks(); // 再取得して表示更新
  };
  

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center" }}>
        🔗 ReiNoInori のリンク付きコメント（{reiLinks.length}件）
        <Button
          variant="outlined"
          size="small"
          onClick={handleDeleteReiFields}
          sx={{ ml: 2 }}
          disabled={loading}
        >
          一括削除
        </Button>
      </Typography>
      <List>
        {reiLinks.map((item) => (
          <ListItem key={item.id} alignItems="flex-start">
            <ListItemText
              primary={`${item.index}. ${item.comment}`}
              secondary={`ID: ${item.id}`}
            />
          </ListItem>
        ))}
      </List>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center" }}>
        🔗 reviewableDDPs のリンク付きアドバイス（{ddpLinks.length}件）
        <Button
          variant="outlined"
          size="small"
          onClick={handleDeleteDDPAdvice}
          sx={{ ml: 2 }}
          disabled={loading}
        >
          一括削除
        </Button>
      </Typography>
      <List>
        {ddpLinks.map((item) => (
          <ListItem key={`${item.id}-${item.index}`} alignItems="flex-start">
            <ListItemText
              primary={`${item.index}. ${item.comment}`}
              secondary={`ID: ${item.id} / advice index: ${item.adviceIndex}`}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default LinkCommentList;
